const consolidatedMonthlyActivityTemplate = (() => {
    const main = {
        "1": {
            "config": {
                "class": "container"
            },
            "tag": "div",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "monthly-summery"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "row pt-3"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 3
        },
        "5": {
            "config": {
                "class": "pb-0"
            },
            "tag": "h4",
            "parent": 4,
            "html": "Summary & Monthly Activity"
        },
        "6": {
            "config": {
                "class": "col"
            },
            "tag": "div",
            "parent": 3
        },
        "7": {
            "config": {
                "class": "form-inline"
            },
            "tag": "form",
            "parent": 6
        },
        "8": {
            "config": {},
            "tag": "fieldset",
            "parent": 7
        },
        "9": {
            "config": {
                "class": "sr-only"
            },
            "tag": "legend",
            "parent": 8,
            "html": "select"
        },
        "10": {
            "config": {
                "class": "input-group mb-2"
            },
            "tag": "div",
            "parent": 8
        },
        "11": {
            "config": {
                "class": "fonr-control",
                "for": "monthySummary"
            },
            "tag": "label",
            "parent": 10,
            "html": "Select"
        },
        "12": {
            "config": {
                "class": "custom-select ml-3 accountNumberMonthlyActivityFilter",
                "id": "monthySummary"
            },
            "tag": "select",
            "parent": 10,
            "events": [
                {
                    "id": "monthySummary",
                    "name": "change",
                    "callback": "getSelectedValue"
                }
            ]
        },
        "17": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 3
        },
        "18": {
            "config": {
                "class": "nav nav-tabs graphicalView float-right"
            },
            "tag": "ul",
            "parent": 17
        },
        "19": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 18
        },
        "20": {
            "config": {
                "class": "nav-link",
                "id": "hideShowGraphicalView",
                "data-toggle": "tab",
                "href": "#graphicalView"
            },
            "tag": "a",
            "parent": 19,
            "html": "Graphical View",
            "events": [
                {
                    "id": "hideShowGraphicalView",
                    "name": "click",
                    "callback": "hideShowSections"
                }
            ]
        },
        "21": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 18
        },
        "22": {
            "config": {
                "class": "nav-link tableview",
                "id": "hideShowTableView",
                "data-toggle": "tab",
                "href": "#tableview"
            },
            "tag": "a",
            "parent": 21,
            "html": "Table View",
            "events": [
                {
                    "id": "hideShowTableView",
                    "name": "click",
                    "callback": "hideShowSections"
                }
            ]
        },
        "23": {
            "config": {
                "class": "monthaly-summary hideShowSection1",
                "id": "graphicalView",
            },
            "tag": "div",
            "parent": 1
        },
        "24": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 23
        },
        "25": {
            "config": {
                "class": "col-4 monthlySummaryLeftcard"
            },
            "tag": "div",
            "parent": 24
        },
        "47": {
            "config": {
                "class": "col-8"
            },
            "tag": "div",
            "parent": 24
        },
        "48": {
            "config": {
                "class": "card summary-graph p-0"
            },
            "tag": "div",
            "parent": 47
        },
        "49": {
            "config": {
                "class": "card-body p-0"
            },
            "tag": "div",
            "parent": 48
        },
        "50": {
            "config": {
                "class": "tab-content"
            },
            "tag": "div",
            "parent": 49
        },
        "51": {
            "config": {
                "class": "tab-pane container active",
                "id": "graphOne"
            },
            "tag": "div",
            "parent": 50
        },
        "53": {
            "config": {
                "class": "tab-pane container fade",
                "id": "graphTwo"
            },
            "tag": "div",
            "parent": 50
        },
        "55": {
            "config": {
                "class": "card-footer p-0"
            },
            "tag": "div",
            "parent": 48
        },
        "56": {
            "config": {
                "class": "nav nav-tabs nav-justified"
            },
            "tag": "ul",
            "parent": 55
        },
        "57": {
            "config": {
                "class": "nav-item text-left"
            },
            "tag": "li",
            "parent": 56
        },
        "58": {
            "config": {
                "class": "nav-link active",
                "data-toggle": "tab",
                "id": "graphOne",
                "href": "#graphOne"
            },
            "tag": "a",
            "parent": 57
        },
        "59": {
            "config": {},
            "tag": "span",
            "parent": 58,
            "html": "Operational Trends"
        },
        "60": {
            "config": {
                "class": "graph-list"
            },
            "tag": "div",
            "parent": 58
        },
        "78": {
            "config": {
                "id": "monthlyActivityGraph1"
            },
            "tag": "ul",
            "parent": 60
        },
        "61": {
            "config": {
                "class": "nav-item text-left"
            },
            "tag": "li",
            "parent": 56
        },
        "62": {
            "config": {
                "class": "nav-link",
                "id": "graphTwo",
                "data-toggle": "tab",
                "href": "#graphTwo"
            },
            "tag": "a",
            "parent": 61
        },
        "63": {
            "config": {},
            "tag": "span",
            "parent": 62,
            "html": "Transfer Activity"
        },
        "85": {
            "config": {
                "class": "graph-list"
            },
            "tag": "div",
            "parent": 62
        },
        "86": {
            "config": {
                "id": "monthlyActivityGraph2"
            },
            "tag": "ul",
            "parent": 85
        },
        "65": {
            "config": {
                "id": "tableview",
                "class": "listStatement card p-0 hideShowSection2"
            },
            "tag": "div",
            "parent": 1
        },
        "66": {
            "config": {
                "class": "data-wrap-fixed row m-0"
            },
            "tag": "div",
            "parent": 65
        },
        "67": {
            "config": {
                "class": "col-1 dataLeft-fixed p-0 dataLeftFixedMonthlyActivity"
            },
            "tag": "div",
            "parent": 66
        },
        "73": {
            "config": {
                "class": "col-10 p-0"
            },
            "tag": "div",
            "parent": 66
        },
        "74": {
            "config": {
                "class": "mid-panel midPanelMonthlyActivity"
            },
            "tag": "div",
            "parent": 73
        },
        "75": {
            "config": {
                "class": "data-head"
            },
            "tag": "div",
            "parent": 74,
            "html": "                                             "
        },
        "77": {
            "config": {
                "class": "col-1 dataRight-fixed p-0 dataRightFixedMonthlyActivity"
            },
            "tag": "div",
            "parent": 66
        }
    };
    const left_card = {
        "1": {
            "config": {
                "id": "graphicalViewtab",
                "class": "revenue"
            },
            "tag": "div"
        },
        "27": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 1
        },
        "28": {
            "config": {
                "class": "col-12"
            },
            "tag": "div",
            "parent": 27
        },
        "29": {
            "config": {},
            "tag": "h5",
            "parent": 28,
            "html": "Average Monthly Credits"
        },
        "30": {
            "config": {
                "class": "col-12 text-right pl-0"
            },
            "tag": "div",
            "parent": 27
        },
        "31": {
            "config": {
                "class": "font-lg monthlySummaryAvgRevenue"
            },
            "tag": "span",
            "parent": 30,
            "html": "{callback separateNumberByCommaAndRoundOffwithSign avg_deposits}"
            // "html": "{callback roundOff avg_renvenue separateNumberByDelimiterWithSignAndThousand}"
        },
        "32": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 1
        },
        "33": {
            "config": {
                "class": "col-12"
            },
            "tag": "div",
            "parent": 32
        },
        "34": {
            "config": {},
            "tag": "h5",
            "parent": 33,
            "html": "Average Monthly Debits"
        },
        "35": {
            "config": {
                "class": "col-12 text-right pl-0"
            },
            "tag": "div",
            "parent": 32
        },
        "36": {
            "config": {
                "class": "font-lg"
            },
            "tag": "span",
            "parent": 35,
            "html": "{callback separateNumberByCommaAndRoundOffwithSign avg_withdrawals}"
            // "html": "{callback roundOff avg_operating_cost separateNumberByDelimiterWithSignAndThousand}"
        },
        "37": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 1
        },
        "38": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 37
        },
        "39": {
            "config": {},
            "tag": "h5",
            "parent": 38,
            "html": "Average Negative Days"
        },
        "40": {
            "config": {
                "class": "col-6 text-right pl-0"
            },
            "tag": "div",
            "parent": 37
        },
        "41": {
            "config": {
                "class": "font-lg"
            },
            "tag": "span",
            "parent": 40,
            "html": "{avg_no_of_negative_days}"
        },
        "42": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 1
        },
        "43": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 42
        },
        "44": {
            "config": {},
            "tag": "h5",
            "parent": 43,
            "html": "# of NSFs"
        },
        "45": {
            "config": {
                "class": "col-6 text-right pl-0"
            },
            "tag": "div",
            "parent": 42
        },
        "46": {
            "config": {
                "class": "font-lg"
            },
            "tag": "span",
            "parent": 45,
            "html": "{total_nsf}"
        }
    };
    return {
        main,
        left_card
    };
})();
